import React from 'react'

// material UI
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepButton from '@mui/material/StepLabel'

const NavStepper = props => {
  const {
    orientation,
    alternativeLabel,
    steps,
    currentStep,
    onClickStep // via withEventHandlers
  } = props

  // add vertical margin only for horizontal stepper
  const marginY = orientation === 'vertical' ? 0 : 3

  return (
    <Stepper
      orientation={orientation}
      activeStep={currentStep.index}
      alternativeLabel={alternativeLabel}
    >
      {steps.map((step, index) => (
        <Step key={step.path} sx={{ my: marginY, cursor: 'pointer' }}>
          <StepButton onClick={onClickStep(step)}>{step.label}</StepButton>
        </Step>
      ))}
    </Stepper>
  )
}

export default NavStepper
